<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-14 11:18:13
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-01 10:17:01
-->
<template>
  <div class="org-box">
    <div class="table-box">
      <el-table
        :data="resData"
        row-key="id"
        ref="sortTable"
        :key="isUpdate"
        :expand-row-keys="keys"
        highlight-current-row
        :height="sortTableHeight"
        lazy
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column  prop="columnName" label="栏目名称"> </el-table-column>
        <el-table-column prop="id" width="120" label="栏目ID"> </el-table-column>
        <el-table-column prop="folder" :ellipsis="true" width="120" label="访问路径"> </el-table-column>
        <el-table-column prop="isNavigation" width="120" label="是否导航">
          <template slot-scope="scope">
            {{ scope.row.isNavigation ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="120">
          <template slot-scope="scope">
            <div class="sort">
              <div @click="up(scope.row)" class="sort-box">
                <i   class="ri-arrow-up-line"></i>
              </div>
              <input disabled v-model="scope.row.sort" class="sort-style" />
              <div @click="down(scope.row)" class="sort-box-two">
                <i    class="ri-arrow-down-line"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right"  label="操作" width="270">
          <template slot-scope="scope">
              <div style="display: flex;padding-left:20px">
                  <div  class="btnTwo" style="margin-right: 14px;width:66px"  v-if="codeData.indexOf('81') != -1" @click="addAdminFn(scope.row)">添加栏目</div>
                  <div
                    @click="editAdmin(scope.row)"
                    v-if="codeData.indexOf('82') != -1 && scope.row.parentId != 0"
                    style="margin-right: 14px"
                    class="btnTwo"
                    >编辑</div
                  >
                  <div
                    @click="open(scope.row)"
                    class="btnThree"
                    v-if="scope.row.parentId != 0 && codeData.indexOf('83') != -1"
                    >删除</div
                  >
              </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="确认删除栏目?"
        :visible.sync="dialogVisibleTwo"
        width="450px"
        custom-class="tips-box"
        top="17%"
      >
        <span
          >栏目删除是不可逆的操作，删除后，与该栏目关联的资源内容将失去关联</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleTwo = false">取消</el-button>
          <el-button :loading="deleteShow" type="danger" @click="deleteOne">确认删除</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { deleteFn, updateSort } from "./column_management";
import {getListByParentId} from './column_management'
export default {
  data() {
    return {
      dialogVisibleTwo: false,
      item: {},
      sortTableHeight: 800,
      codeData:[],
      keys:[],
      resData:[],
      oldData:[],
      treeNodeMap:[],
      deleteShow:false,
      isUpdate:0,
      maps:new Map(),
      homeOneId:0,
    };
  },
  components:{

  },
  created(){
     this.newsData = JSON.parse(JSON.stringify(this.resData))
  },
  mounted() {
    this.getTableHeight();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.getList();
    window.onresize = () => {
            return (() => {
              this.getTableHeight();
            })();
          };
  },
  methods: {
    load(tree, treeNode, resolve){
         this.treeNodeMap.push({
            parentId:tree.id,
            node:{tree, treeNode, resolve},
         })
         this.maps.set(tree.id, resolve);
         getListByParentId({
            columnName:this.value,
            siteId:sessionStorage.getItem('siteId'),
            parentId:tree.id,
          }).then((res)=>{
            if(res.code == 0){
              if(res.data.length == 0){
                const resolve = this.maps.get(tree.id)
                this.$set(this.$refs.sortTable.store.states.lazyTreeNodeMap, tree.id, [])
                resolve(res.data)
              }else{
                resolve(res.data) 
              }
            }
        })
    },
    getList(value=''){
        this.$emit('isLoading',true)
        getListByParentId({
            columnName:value?value:null,
            siteId:sessionStorage.getItem('siteId'),
            parentId:0,
          }).then((res)=>{
            if(res.code == 0){
                this.resData = JSON.parse(JSON.stringify(res.data));
                this.homeOneId = this.resData.length > 0? this.resData[0].id:'';
                this.$emit('isLoading',false)
                if(!value){
                    this.$nextTick(()=>{
                      if(document.getElementsByClassName('el-table__expand-icon')[0]){
                           document.getElementsByClassName('el-table__expand-icon')[0].click();
                      }
                  });
                }
            }
        })
    },
    searchRefreshData(){
          for (let index = 0; index < this.treeNodeMap.length; index++) {
            const element = this.treeNodeMap[index];
            const {tree} = element.node
                if(tree){
                   getListByParentId({
                      columnName:this.value,
                      siteId:sessionStorage.getItem('siteId'),
                      parentId:tree.id,
                    }).then((res)=>{
                      if(res.code == 0){
                          const resolve = this.maps.get(tree.id)
                          this.$set(this.$refs.sortTable.store.states.lazyTreeNodeMap, tree.id, [])
                          resolve(res.data)
                      }
                  })
                }
          } 
    },
     refreshData(pid) {
       let node = {};
       if(pid==0){
          pid = 1;
       }
       for (let index = 0; index < this.treeNodeMap.length; index++) {
        const element = this.treeNodeMap[index];
        if(pid == element.parentId){
            node = element.node;
        }
      }
      // 获取需要刷新节点
      const {tree, treeNode, resolve} = node
       if(tree){
          this.load(tree, treeNode, resolve);
       }
     
    },
      getObjById(list, id) {
        for(let i in list){
            let item = list[i];
            if(item.id == id){
                return i;
            }else {
                if(item.children) {
                    let obj = this.getObjById(item.children, id);
                    if(obj){
                      return obj;
                    }
                }
            }
        }
    },
     parentTree(arr, id) {   //arr 所有的树数据 id 某个子节点的id 
      var temp = [];
      var callback = function (nowArr, id) {     //先定义个函数寻找子节点位置 找到后 再找改节点父元素位置 以此类推
        for (var i = 0; i < nowArr.length; i++) {
          var item = nowArr[i];
          if (item.id === id) {
            temp.push(item);
            callback(arr, item.parentId);     //pid 父级ID
            break;
          } else {
            if (item.children) {
              callback(item.children, id); //menus 子节点字段名称
            }
          }
        }
      };
      callback(arr, id);
      return temp;  //最后返回
    },
    getTableHeight() {
      this.$nextTick(function () {
        let exceptHeight = 260;
        // this.$refs.table.$el.offsetTop：表格距离浏览器的高度
        if (this.$refs.sortTable.$el) {
          this.sortTableHeight =
            window.innerHeight -
            this.$refs.sortTable.$el.offsetTop -
            exceptHeight;
        }

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          if (self.$refs.sortTable.$el) {
            self.sortTableHeight =
              window.innerHeight -
              self.$refs.sortTable.$el.offsetTop -
              exceptHeight;
          }
        };
      });
    },
    up(item) {
      updateSort({
        id: item.id,
        sort: Number(item.sort) - 1,
      }).then((res) => {
        if (res.code == 0) {
            this.refreshData(item.parentId)
        }
      });
    },
    down(item) {
      updateSort({
        id: item.id,
        sort: Number(item.sort) + 1,
      }).then((res) => {
        if (res.code == 0) {
             this.refreshData(item.parentId)
        }
      });
    },
    editAdmin(item) {
       this.setOpenId(item);
      this.$emit("editAdmin", item);
    },
    open(item) {
      this.item = item;
      this.dialogVisibleTwo = true;
    },
    setOpenId(item){
       let dems = this.parentTree(this.resData, item.id);
      let arrayId = [];
      for (let index = 0; index < dems.length; index++) {
       arrayId.push(`${dems[index].id}`)
      }
      sessionStorage.setItem('openIds',JSON.stringify(arrayId.reverse()))
    },
    addAdminFn(item) {
     this.setOpenId(item);
      this.$emit("addAdminFn", item);
    },
    deleteOne() {
      this.deleteShow = true;
      deleteFn({
        id: this.item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.refreshData(this.item.parentId)
        }
         this.deleteShow = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__body {
  color: #000;
}
/deep/ .has-gutter {
  color: #000;
  font-weight: 800;
}

.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  cursor: pointer;
   display: flex;
  justify-content: center;
  align-items: center;
}
.table-box {
  padding: 24px;
}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
.delete-input {
  margin-top: 24px;
}
/deep/ .el-dialog__footer {
  padding-top: 0px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-icon-arrow-right {
  font-size: 18px;
  color: #a9aab1;
}

/deep/ .el-table .el-table__expand-icon {
  .el-icon-arrow-right:before {
    content: "\e791";
  }
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-box {
  position: relative;
  width: 100%;
  padding: 0px;
  .el-table {
    position: absolute;
    width: 100%;
  }
}
.org-box {
  padding: 24px;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/deep/ .el-table__fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
} 
/deep/ .el-table th.el-table__cell>.cell{
    color: #606266;
} 
/deep/ .el-table__fixed-right-patch{
  width: 0px !important;
  height: 0px !important;
}
/deep/ .el-table__header th:last-child{
  padding-left: 20px;
}
/deep/ .el-table__body{
  color: #303133 !important;
}
/deep/ .el-table__header {
  th {
    background-color: rgba(245, 247, 250, 1) !important;
    height: 48px;
  }
}
/deep/ .el-table td.el-table__cell{
     height: 50px;
     padding: 0;
}
/deep/ .el-table__body tr:hover>td{
  background-color: #fafafa !important;
}
/deep/ .el-table__body tr.hover-row >td.el-table__cell{
  background-color: #fafafa !important;
}
 
</style>